module.exports = __webpack_public_path__ + "spotlight4.a4a2eb8d53a462128d624cb785dfd660.png";